<template>
  <el-tabs :model-value="activePath" @update:model-value="onTabChange">
    <el-tab-pane
      v-for="item in localItems"
      :key="item.route"
      :name="item.route"
    >
      <template #label>
        {{ item.label }}
        <router-link :to="item.fullRoute" class="absolute inset-0" />
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  }
})

const route = useRoute()
const router = useRouter()
const activePath = ref()

const localItems = computed(() =>
  props.items.map((item) => ({
    ...item,
    fullRoute: item.query ? `${item.route}?${item.query}` : item.route
  }))
)

/**
 * Handles keyboard navigation
 */
function onTabChange(route) {
  const item = localItems.value.find((item) => item.route === route)

  if (!item) {
    return
  }

  router.push(item.fullRoute)
}

watch(
  route,
  ({ path }) => {
    activePath.value = path
  },
  { immediate: true }
)
</script>

<style scoped>
.el-tabs :deep(.el-tabs__header) {
  @apply mb-0;
}

.el-tabs :deep(.el-tabs__content) {
  @apply hidden;
}

:deep(.el-tabs__nav-prev) {
  @apply transition duration-150;
}

/* 
 * Hide the left arrow when the action is not available (user has not scrolled any amount)
 */
:deep(.el-tabs__nav-prev.is-disabled) {
  @apply opacity-0 pointer-events-none hidden;
}

:deep(.el-tabs__nav-prev.is-disabled ~ .el-tabs__nav-scroll) {
  @apply -ml-5;
}
</style>
